import { getMedia } from '@/infra/services' //Media query.
import { ROUTER_PATH, ROUTES } from './routes/translations'
const CMSApi = process.env.NEXT_PUBLIC_API_CMS

const CMS_SEO_CENTERApi = process.env.NEXT_PUBLIC_API_SEO_CENTER
const DOMAIN_LOCALE_MAP: Record<string, string> = {
  etichetta: 'it',
  etiqueta: 'es',
  unieketiket: 'nl',
  primelabels: 'au',
  labelletiquette: 'fr',
  etikett: 'de',
  labelmakers: 'us',
  label: 'uk'
}

type UrlItem = {
  url: string
}

type AlternateMap = Record<string, string>

const getDomainByLocale = (locale: string) => {
  switch (locale) {
    case 'es':
      return 'https://etiqueta.es'
    case 'it':
      return 'https://etichetta.it'
    case 'au':
      return 'https://primelabels.com.au'
    case 'nl':
      return 'https://unieketiket.nl'
    case 'fr':
      return 'https://labelletiquette.fr'
    case 'de':
      return 'https://etikett.de'
    case 'us':
      return 'https://labelmakers.com'
    case 'uk':
      return 'https://label.co.uk'
    default:
      return process.env.DOMAIN_URL
  }
}

const getSEOCenterData = async (slug, id) => {
  console.log(
    `${CMS_SEO_CENTERApi}/${slug}_alternate_tag?slug=${id == '' ? 'home' : id}`,
    `${CMS_SEO_CENTERApi}/${slug}?${slug}_alternate_tag=${0}`
  )
  try {
    console.time('SEO alternate fetch')
    const seoCenterForAlternateID = await fetch(
      `${CMS_SEO_CENTERApi}/${slug}_alternate_tag?slug=${id == '' ? 'home' : id}`,
      {
        next: { revalidate: 3600 }
      }
    )
    console.timeEnd('SEO alternate fetch')
    const [alternateID] = await seoCenterForAlternateID.json()

    console.log(
      `${CMS_SEO_CENTERApi}/${slug}_alternate_tag?slug=${id}&_fields=id`,
      `${CMS_SEO_CENTERApi}/${slug}?${slug}_alternate_tag=${alternateID?.id || 0}`
    )
    const exactPageFromAlternateID = await fetch(
      `${CMS_SEO_CENTERApi}/${slug}?${slug}_alternate_tag=${alternateID?.id || 0}`,
      {
        next: { revalidate: 3600 }
      }
    )

    const [seoData] = await exactPageFromAlternateID.json()
    return seoData
  } catch {
    return null
  }
}

export const getCMSGeneralContent = async (locale) => {
  const CMSApi = process.env.NEXT_PUBLIC_API_CMS
  const headerSlug = ROUTES['HEADER'][locale || process.env.NEXT_DEFAULT_LOCALE]
  const footerSlug = ROUTES['FOOTER'][locale || process.env.NEXT_DEFAULT_LOCALE]
  const resHeader = await fetch(`${CMSApi}/pages?slug=${headerSlug}&acf_format=standard&lang=${locale}`)
  const header = await resHeader.json()
  const resFooter = await fetch(`${CMSApi}/pages?slug=${footerSlug}&acf_format=standard&lang=${locale}`)
  const footer = await resFooter.json()

  return {
    header: header[0]?.acf,
    footer: footer[0]?.acf
  }
}

const isValidUrl = (str) => {
  try {
    new URL(str)
    return true // valid URL
  } catch (e) {
    return false // invalid URL
  }
}

const generateCanonicalTag = (url) => {
  if (url) {
    return url
  } else {
    return ''
  }
}

const getLocaleFromHostname = (hostname: string): string | null => {
  for (const keyword in DOMAIN_LOCALE_MAP) {
    if (hostname.includes(keyword)) {
      return DOMAIN_LOCALE_MAP[keyword]
    }
  }

  return null
}

const generateCanonicalTagForDynamicPost = (url, slug, id) => {
  if (url) {
    return url
  } else {
    return process.env.DOMAIN_URL + '/' + slug + '/' + id
  }
}

// const generateAlternateTag = (page) => {
//   const routePaths = ROUTER_PATH[page]
//   const ALLOWED_LOCALES = new Set(Object.values(DOMAIN_LOCALE_MAP))
//   const routesWithDomain = Object.fromEntries(
//     Object.entries(routePaths)
//       .filter(([key]) => ALLOWED_LOCALES.has(key))
//       .map(([key, value]) => [key, `${getDomainByLocale(key)}${value}`])
//   )
//   return routesWithDomain
// }

type AlternateLink = {
  domain: string
  hreflang: string
  slug: string
}

type Hreflang = {
  hreflang: string
  href: string
}

const generateAlternateTag = (items: AlternateLink[] = []): Hreflang[] => {
  if (!items.length) return []

  return items
    .map(({ domain, hreflang, slug }) => {
      try {
        const base = domain.replace(/\/$/, '')
        const path = slug.startsWith('/') ? slug : `/${slug}`

        const href = new URL(path, base).toString()

        return {
          hreflang,
          href
        }
      } catch (e) {
        return null
      }
    })
    .filter(Boolean) as Hreflang[]
}

// get media info.
const getMediaInfo = async (locale, mediaId) => await getMedia(locale || 'en', mediaId)

const updateCMSURL = (locale) => {
  if (!locale) return `https://es.cms.etikett.de/wp-json/wp/v2`
  return `https://${locale}.cms.etikett.de/wp-json/wp/v2`
}

// const getTotalList = async (slug) => {
//   const CMSApi = process.env.NEXT_PUBLIC_API_CMS
//   const defaultLocale = process.env.NEXT_DEFAULT_LOCALE
//   const CMSQueryList = ['es', 'it', 'nl', 'fr', 'us', 'de'].filter((e) => e !== defaultLocale)

//   // eslint-disable-next-line @typescript-eslint/no-unused-vars
//   let CMSApiCurrent = ''
//   // Wait for all requests to finish
//   const results = await Promise.all(
//     CMSQueryList.map(async (currentLocale) => {
//       switch (currentLocale) {
//         case 'es':
//           CMSApiCurrent = updateCMSURL(currentLocale)
//         case 'nl':
//           CMSApiCurrent = updateCMSURL(currentLocale)
//         case 'it':
//           CMSApiCurrent = updateCMSURL(currentLocale)
//         case 'fr':
//           CMSApiCurrent = updateCMSURL(currentLocale)
//       }
//       const res = await fetch(`${CMSApi}/pages?slug=${slug}&acf_format=standard&lang=${currentLocale}&_fields=slug`)
//       const [data] = await res.json()

//       return { locale: currentLocale, data } // return structured results
//     })
//   )
//   return results
// }

export const getCMSContent = async (defaultLocale, locale, page) => {
  // eslint-disable-next-line no-console
  const slug = ROUTES[page][defaultLocale || process.env.NEXT_DEFAULT_LOCALE]
  const routerPath = ROUTER_PATH[page][defaultLocale || process.env.NEXT_DEFAULT_LOCALE]

  // eslint-disable-next-line no-console
  console.log(`${CMSApi}/pages?slug=${slug}&acf_format=standard&lang=${locale}`)
  const res = await fetch(`${CMSApi}/pages?slug=${slug}&acf_format=standard&lang=${locale}`)
  const [data] = await res.json()

  // await getTotalList(slug)

  const mediaId = (data && data['featured_media']) || 0
  const featuredImage_url = await getMediaInfo(locale, mediaId)
  const { header, footer } = await getCMSGeneralContent(locale)

  // Canonical Tag.
  const currentURL = isValidUrl(data?.yoast_head_json?.canonical) ? data?.yoast_head_json.canonical : null
  // Not in use, since site uses the same browser URL for canonical tag (Saif).
  // const canonicalTag = generateCanonicalTag(currentURL)

  // Alternate Tag.
  // const alternateTag = generateAlternateTag(page)
  const seoData = await getSEOCenterData('static_pages', routerPath.replace(/^\/|\/$/g, ''))

  const alternateTag = generateAlternateTag(seoData?.acf?.alternate_links || [])
  const seo = {
    ...data?.yoast_head_json,
    canonicalUrl: '',
    alternateTags: alternateTag,
    domain: getDomainByLocale(defaultLocale),
    featured_media: data?.featured_media || 0,
    source_url: featuredImage_url['source_url'] || '0'
  }

  return {
    seo: seo,
    content: data?.acf,
    header,
    footer,
    additionalInfo: data?.link || ''
  }
}

export const getDynamicCMSContent = async (locale, slug, id) => {
  // API
  const CMSApi = process.env.NEXT_PUBLIC_API_CMS

  const res = await fetch(`${CMSApi}/${slug}?slug=${id}&acf_format=standard&lang=${locale}`)
  const [data] = await res.json()
  const mediaId = (data && data['featured_media']) || 0
  const featuredImage_url = await getMediaInfo(locale, mediaId)
  const meta = { id: data?.id }
  const { header, footer } = await getCMSGeneralContent(locale)
  let seo = null

  //****************************************************** */
  //****************************************************** */
  // SEO

  const seoData = await getSEOCenterData(slug, id)
  //****************************************************** */
  //****************************************************** */

  // Alternate Tag.
  const alternateTag = generateAlternateTag(seoData?.acf?.alternate_links || [])
  seo = {
    ...data?.yoast_head_json,
    date: data?.modified || data?.date || '',
    domain: getDomainByLocale(process.env.NEXT_DEFAULT_LOCALE || locale),
    canonicalUrl: '',
    alternateTags: alternateTag,
    featured_media: data?.featured_media || 0,
    source_url: featuredImage_url['source_url'] || '0'
  }

  return {
    seo: seo,
    content: data?.acf,
    meta: meta,
    header,
    footer
  }
}

export const getCMSFullList = async (locale, slug, id, query, search = '') => {
  const CMSApi = process.env.NEXT_PUBLIC_API_CMS
  const res = await fetch(
    `${CMSApi}/${slug}?slug=${id}&acf_format=standard&lang=${locale}&page=${query.page}&per_page=${6}&search=${search}`
  )

  const data = await res.json()

  const acfResponse =
    data && data.length > 0
      ? data.map((e) => ({
          date: e['modified'] || e['date'],
          featured_media: e['featured_media'],
          link: e['link'],
          ...e['acf']
        }))
      : []

  // Total Pages
  const totalPages = res.headers.get('X-WP-TotalPages')
  const totalItems = res.headers.get('X-WP-Total')

  return {
    acfResponse,
    meta: { totalItems, totalPages, keyword: search }
  }
}

export const getCMSFullListForTag = async (locale, slug, id, query, search = '') => {
  const CMSApi = process.env.NEXT_PUBLIC_API_CMS
  const res = await fetch(
    `${CMSApi}/${slug}?acf_tag=${search}&acf_format=standard&lang=${locale}&page=${query.page}&per_page=${6}`
  )

  const data = await res.json()

  const acfResponse =
    data &&
    data.length > 0 &&
    data.map((e) => ({ date: e['date'], featured_media: e['featured_media'], link: e['link'], ...e['acf'] }))

  // Total Pages
  const totalPages = res.headers.get('X-WP-TotalPages')
  const totalItems = res.headers.get('X-WP-Total')

  return {
    acfResponse,
    meta: { totalItems, totalPages, keyword: search }
  }
}
